import * as React from "react";

export class InstantCollapsible extends React.Component<{
    trigger: JSX.Element
    content: JSX.Element
    initiallyExpanded: boolean
},
    {
        collapsed: boolean
    }> {

    constructor(props) {
        super(props);

        this.state = {
            collapsed: this.props.initiallyExpanded
        };
    }

    toggle = (e: React.MouseEvent<HTMLElement>) => {
        this.setState((prevState) => (
            { collapsed: !prevState.collapsed }
        ));
    }

    render() {
        return (
            <div className="rj-instant-collapsible">
                <div className="rj-instant-collapsible__trigger" onClick={this.toggle}>
                    {this.props.trigger}
                </div>
                {this.state.collapsed && this.props.content}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./components/InstantCollapsible/InstantCollapsible.tsx